import TabTimer from './js/tab-timer.js';
import CabinetPointers from './js/cabinet-pointers.js';
import { searchFacet } from './js/facetwp.js';
import { modal } from './js/modal.js';
import ContentTabs from './js/tabs.js';

searchFacet();
modal();

document.addEventListener('DOMContentLoaded', () => {

    // Initialize all tab timers on the page
    const featuresContainers = document.querySelectorAll('.features');
    featuresContainers.forEach(container => new TabTimer(container));

    // Initialize capture cabinet pointers
    const cabinetContainers = document.querySelectorAll('.capture-cabinet');
    cabinetContainers.forEach(container => new CabinetPointers(container));

    // Initialize all content tabs on the page
    const tabContainers = document.querySelectorAll('.content-tabs');
    tabContainers.forEach(container => {
        tabInstances.push(new ContentTabs(container));
    });

});

const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;
document.querySelector(':root').style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');
